import { http } from "@next-core/http";
/**
 * @description 导入协作空间模式定义（业务对象、关系、业务流）
 * @endpoint POST /api/v1/elevo/spaces/:spaceId/import
 */
export const ElevoSpaceApi_importSpaceSchema = (spaceId, data, options) => /**! @contract easyops.api.llm.elevo_space.ImportSpaceSchema@1.0.0 */http.post(`api/gateway/logic.llm.aiops_service/api/v1/elevo/spaces/${spaceId}/import`, data, options);
//# sourceMappingURL=importSpaceSchema.js.map